module.exports = __webpack_public_path__ + "img/pull_rope.19364a60.jpg";